module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.colorClass]
  }, [_c('i', {
    class: _vm.iconClasses
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d2e1a24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/InfoBox.vue
// module id = 1885
// module chunks = 1